// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserAccountPropertySchema } from './v1/userAccountPropertySchema';

export const listUserAccountPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  user_id: z.number().int().describe("User id"),
});

export const listUserAccountPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description properties list
 */
export const listUserAccountProperties200Schema = z.array(z.lazy(() => v1UserAccountPropertySchema));

export const listUserAccountPropertiesQueryResponseSchema = z.lazy(() => listUserAccountProperties200Schema);
